export default __webpack_public_path__ + "static/ForgotPassword-8be6980a36a2f12eb68b77a38c011015.jpg";